import React, { PropsWithChildren } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { AuthState } from '../../../auth/auth-reducer';
import { State } from '../../../redux/root-reducer';

interface Props {
    isReadOnly: boolean;
    user: AuthState;
}

const buttonWrapper = ({ isReadOnly, children, user }: PropsWithChildren<Props>) => {
    if (isReadOnly || getRole(user)) {
        return null;
    }
    return <React.Fragment>{children}</React.Fragment>;
};

function getRole(user: AuthState) {
    if (!user || !user.roles) {
        return false;
    }

    const roles = ['CentralPayments'];
    return roles.some(role => user.roles.includes(role));
}

const mapStateToProps = (state: State) => ({
    isReadOnly: state.claimSession.readOnly,
    user: state.auth as AuthState,
});
const mapDispatchToProps = {};
export const ButtonWrapper = connect(mapStateToProps, mapDispatchToProps)(buttonWrapper);
